import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { useTranslation } from "react-i18next"

import AuthBrandingLogo from "components/Authentication/AuthBrandingLogo"
import useAuthPageBranding from "hooks/useAuthPageBranding"
import { ROUTES } from "constants/routes"
import { endSession } from "utils/endSession"

const SessionExpired = () => {
  const { t } = useTranslation()
  const { brandTitle, authPageClassName } = useAuthPageBranding(
    t("Session Expired")
  )

  useEffect(() => {
    endSession()
  }, [])

  return (
    <div className={`account-pages ${authPageClassName}`}>
      <Container
        style={{ display: "flex", alignItems: "center", height: "100%" }}
      >
        <Row className="justify-content-center login_form w-100">
          <Col md={12}>
            <Card className="overflow-hidden">
              <div className="login-platform-hero">
                <div className="p-4 text-center">
                  <h5 className="mb-1 text-uppercase">{brandTitle}</h5>
                  <p className="mb-0">{t("Session Expired")}</p>
                </div>
              </div>
              <CardBody className="pt-0">
                <AuthBrandingLogo />
                <div className="p-4 text-center">
                  <h1 className="display-1 fw-bold login-platform-forbidden__code mb-2">
                    <i className="mdi mdi-timer-sand" />
                  </h1>
                  <div className="mb-3">
                    <i className="mdi mdi-clock-alert-outline display-4 login-platform-forbidden__icon" />
                  </div>
                  <h5 className="text-muted mb-3">
                    {t("Your session has expired due to inactivity.")}
                  </h5>
                  <p className="text-muted mb-4">
                    {t(
                      "For your security, you have been automatically logged out. Please log in again to continue."
                    )}
                  </p>
                  <Link to={ROUTES.LOGIN} className="btn btn-primary">
                    <i className="mdi mdi-login me-1" />
                    {t("Log In Again")}
                  </Link>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default SessionExpired
